{
    "Accessibility menu": "Menu de acessibilidade",
    "Reset settings": "Redefinir configurações",
    "Close": "Fechar",
    "Content adjustments": "Ajustes de Conteúdo",
    "Navigation adjustments": "Ajustes de Navegação",
    "Align Left": "Alinhar à Esquerda",
    "Adjust Font Size": "Ajustar Tamanho da Fonte",
    "Highlight Title": "Destacar Título",
    "Highlight Links": "Destacar Links",
    "Readable Font": "Fonte Legível",
    "Colour adjustments": "Ajustes de Cor",
    "Dark Contrast": "Contraste Escuro",
    "Light Contrast": "Contraste Claro",
    "High Contrast": "Alto Contraste",
    "High Saturation": "Alta Saturação",
    "Low Saturation": "Baixa Saturação",
    "Monochrome": "Monocromático",
    "Tools": "Ferramentas",
    "Reading Guide": "Guia de Leitura",
    "Stop Animations": "Parar Animações",
    "Big Cursor": "Cursor Grande",
    "Increase Font Size": "Aumentar Tamanho da Fonte",
    "Decrease Font Size": "Diminuir Tamanho da Fonte",
    "Letter Spacing": "Espaçamento entre Letras",
    "Line Height": "Altura da Linha",
    "Font Weight": "Peso da Fonte",
    "Dyslexia Font": "Fonte para Dislexia",
    "Language": "Idioma",
    "Accessibility widget": "Abrir menu de acessibilidade",
    "Accessibility Profiles": "Perfis de Acessibilidade",
    "Cognitive Disability": "Deficiência Cognitiva",
    "Seizure Safe": "Seguro para Epilepsia",
    "Accessibility statement": "Declaração de Acessibilidade"
}